module.exports = __webpack_public_path__ + "media/images/footer/en_rp-ab54d9aff546d1f7c27979fcd677d835.svg";